module.exports = __webpack_public_path__ + "img/logo-asana.efcb8482.svg";